module.exports = __webpack_public_path__ + "static/media/dub-theme-tetris.de455a82.mp3";